module.exports = __webpack_public_path__ + "img/carbon-footprint.38b25f66.svg";